import React from "react";

function Footer() {
  return (
    <div className="footer">
      <p>
        Made by{" "}
        <a href="https://github.com/TitoGrine" target="_blank" rel="noreferrer">
          TitoGrine
        </a>
      </p>
    </div>
  );
}

export default Footer;
